import { CampaignPropsSchema, EventPropsSchema } from '../../graph-schemas/marketing';
import type { NodeDefinition } from './base-crm';

export const MARKETING_NODES: Record<string, NodeDefinition> = {
  Campaign: {
    type: 'Campaign',
    schema: CampaignPropsSchema,
    displayName: 'Campaign',
    displayNamePlural: 'Campaigns',
    icon: 'Mail',
    color: '#ec4899',
    formFields: [
      { key: 'name', label: 'Name', type: 'text', required: true },
      { key: 'type', label: 'Type', type: 'select', required: true, picklistName: 'campaign_type' },
      { key: 'status', label: 'Status', type: 'select', required: true, picklistName: 'campaign_status' },
      { key: 'start_date', label: 'Start Date', type: 'date' },
      { key: 'end_date', label: 'End Date', type: 'date' },
      { key: 'owner_user_id', label: 'Owner', type: 'text' },
    ],
    pmnEnabled: true,
    relationshipSections: [
      {
        sectionLabel: 'Members',
        icon: 'Users',
        edgeTypes: ['MEMBER_OF'],
        direction: 'incoming',
        renderMode: 'grid',
        columns: [
          { field: 'name', headerName: 'Name', flex: 2, minWidth: 150, source: 'node', editable: false },
          { field: 'email', headerName: 'Email', flex: 1, minWidth: 150, source: 'node', editable: false },
        ],
      },
      {
        sectionLabel: 'Events',
        icon: 'Calendar',
        edgeTypes: ['PART_OF'],
        direction: 'incoming',
        renderMode: 'grid',
        columns: [
          { field: 'name', headerName: 'Event', flex: 2, minWidth: 150, source: 'node', editable: false },
          { field: 'start_datetime', headerName: 'Start', width: 150, type: 'datetime', source: 'node', editable: false },
        ],
      },
    ],
  },
  Event: {
    type: 'Event',
    schema: EventPropsSchema,
    displayName: 'Event',
    displayNamePlural: 'Events',
    icon: 'Calendar',
    color: '#f59e0b',
    formFields: [
      { key: 'name', label: 'Name', type: 'text', required: true },
      { key: 'type', label: 'Type', type: 'select', required: true, picklistName: 'event_type' },
      { key: 'status', label: 'Status', type: 'select', required: true, picklistName: 'event_status' },
      { key: 'start_datetime', label: 'Start', type: 'datetime', required: true },
      { key: 'end_datetime', label: 'End', type: 'datetime' },
      { key: 'owner_user_id', label: 'Owner', type: 'text' },
    ],
    pmnEnabled: true,
    relationshipSections: [
      {
        sectionLabel: 'Registrations',
        icon: 'Users',
        edgeTypes: ['REGISTERED_FOR'],
        direction: 'incoming',
        renderMode: 'grid',
        columns: [
          { field: 'name', headerName: 'Name', flex: 2, minWidth: 150, source: 'node', editable: false },
          { field: 'email', headerName: 'Email', flex: 1, minWidth: 150, source: 'node', editable: false },
        ],
      },
      {
        sectionLabel: 'Campaign',
        icon: 'Mail',
        edgeTypes: ['PART_OF'],
        direction: 'outgoing',
        renderMode: 'grid',
        columns: [
          { field: 'name', headerName: 'Campaign', flex: 2, minWidth: 150, source: 'node', editable: false },
          { field: 'status', headerName: 'Status', width: 120, source: 'node', editable: false },
        ],
      },
    ],
  },
};
